import Cart from "../components/Cart";

function CartPage() {
  return <Cart />;
}

export default CartPage;